import { render, staticRenderFns } from "./SpecialArea.vue?vue&type=template&id=013957ca&scoped=true"
import script from "./SpecialArea.vue?vue&type=script&lang=js"
export * from "./SpecialArea.vue?vue&type=script&lang=js"
import style0 from "./SpecialArea.vue?vue&type=style&index=0&id=013957ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013957ca",
  null
  
)

export default component.exports